module.exports = __webpack_public_path__ + "img/domain_sequence.e12cfa47.png";